import { z } from "zod";

export const LEGAL_DOCUMENT_TYPES = ["TERMS", "PRIVACY"] as const;

export const legalDocumentTypeSchema = z.enum(LEGAL_DOCUMENT_TYPES);

export type LegalDocumentType = z.infer<typeof legalDocumentTypeSchema>;

export const LEGAL_DOCUMENT_LABELS: Record<LegalDocumentType, string> = {
  TERMS: "Términos y Condiciones",
  PRIVACY: "Política de Privacidad",
};

export const pendingLegalDocumentSchema = z.object({
  type: legalDocumentTypeSchema,
  versionPublicId: z.string(),
  version: z.number(),
});

export type PendingLegalDocument = z.infer<typeof pendingLegalDocumentSchema>;

export const legalDocumentContentSchema = z.object({
  publicId: z.string(),
  type: legalDocumentTypeSchema,
  version: z.number(),
  content: z.string(),
  publishedAt: z.string(),
});

export type LegalDocumentContent = z.infer<typeof legalDocumentContentSchema>;

export const publishedLegalDocumentSchema = z.object({
  publicId: z.string(),
  type: legalDocumentTypeSchema,
  version: z.number(),
  publishedAt: z.string(),
  publishedByEmail: z.string(),
});

export type PublishedLegalDocument = z.infer<
  typeof publishedLegalDocumentSchema
>;

export const legalDocumentHistoryItemSchema = z.object({
  publicId: z.string(),
  type: legalDocumentTypeSchema,
  version: z.number(),
  publishedAt: z.string(),
  publishedByEmail: z.string(),
  isCurrent: z.boolean(),
  acceptanceCount: z.number(),
});

export type LegalDocumentHistoryItem = z.infer<
  typeof legalDocumentHistoryItemSchema
>;

export const legalDocumentHistorySchema = z.object({
  items: z.array(legalDocumentHistoryItemSchema),
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
});

export type LegalDocumentHistory = z.infer<typeof legalDocumentHistorySchema>;

export const legalAcceptanceItemSchema = z.object({
  publicId: z.string(),
  email: z.string(),
  acceptedAt: z.string(),
  documentType: legalDocumentTypeSchema,
  version: z.number(),
  userPublicId: z.string(),
  userFullName: z.string(),
  userDeleted: z.boolean(),
  gymPublicId: z.string().nullable(),
  gymName: z.string().nullable(),
});

export type LegalAcceptanceItem = z.infer<typeof legalAcceptanceItemSchema>;

export const legalAcceptanceListSchema = z.object({
  items: z.array(legalAcceptanceItemSchema),
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
});

export type LegalAcceptanceList = z.infer<typeof legalAcceptanceListSchema>;

export const acceptLegalResponseSchema = z.object({
  mustAcceptTerms: z.boolean(),
  pendingLegalDocuments: z.array(pendingLegalDocumentSchema),
});

export type AcceptLegalResponse = z.infer<typeof acceptLegalResponseSchema>;
